
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.412 12.235V6.588h3.764L6.589 0 0 6.588h3.765v5.647h5.647zM6.586 2.664L8.63 4.706H7.528v5.647H5.645V4.706h-1.1l2.041-2.042zM13.176 16v-1.882H0V16h13.177z","fill":"#585858"}})])
          )
        }
      }
    